/**
 * Routes the browser must send a BotID token to. Every route whose handler calls
 * rejectBot() has to be listed here with the method the site fetches it with, or
 * checkBotId() sees no token and real visitors get a 403.
 *
 * `basic` is the free level. It must match the level rejectBot() asks for, and
 * a per-route level overrides the project setting, so turning on the paid Deep
 * Analysis in the dashboard does not start billing these routes.
 */
export const BOTID_CHECK_LEVEL = 'basic' as const;

export const BOTID_PROTECTED_ROUTES = [
  { path: '/api/app-detail/core', method: 'GET' },
  { path: '/api/app-country-rankings', method: 'GET' },
  { path: '/api/rankings', method: 'GET' },
  { path: '/api/app-revenue-history', method: 'GET' },
  { path: '/api/app-detail/similar', method: 'GET' },
  { path: '/api/developer/estimates', method: 'GET' },
  { path: '/api/app-detail/overview', method: 'GET' },
].map((route) => ({ ...route, advancedOptions: { checkLevel: BOTID_CHECK_LEVEL } }));
